// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement, Alert, Component, Fragment, Translate, Dialog, Button, PropTypes, Toaster } from '@plesk/ui-library';
import Plesk from '../../plesk';

const TYPE_SEND_ANNOUNCE = 'send_announce';
const TYPE_SEND_PERSONALIZED_ANNOUNCE = 'send_personalized_announce';
const TYPE_NONE = 'none';

class NewsletterSubscription extends Component {
    state = {
        isOpen: true,
        state: null,
    };

    getText() {
        return this.context.locale.lmsg(this.needReconfirmConsent() ? 'reconfirmConsent' : 'consent');
    }

    needReconfirmConsent = () => {
        const { consents } = this.props;

        return consents.some(consent => consent.enabled && consent.type === TYPE_SEND_ANNOUNCE)
            && !consents.some(consent => consent.enabled && consent.type === TYPE_SEND_PERSONALIZED_ANNOUNCE);
    };

    hasConsent = () => {
        const { consents } = this.props;

        return consents.some(consent => consent.enabled);
    };

    renderInfo = () => {
        if (this.needReconfirmConsent()) {
            return (
                <Alert intent="info">
                    <Translate content="consentGivenInfo" />
                </Alert>
            );
        }

        if (this.props.dialogShown && !this.hasConsent()) {
            return (
                <Alert intent="info">
                    <Translate content="consentNotGivenInfo" />
                </Alert>
            );
        }
    };

    handleSubscribe = () => {
        const { email, reportConsent, reportConsentUrl } = this.props;

        this.setState({
            state: 'submit',
        });

        reportConsent(
            reportConsentUrl,
            email,
            TYPE_SEND_PERSONALIZED_ANNOUNCE,
            this.getText(),
            success => {
                this.setState({
                    state: null,
                    isOpen: false,
                });

                if (success) {
                    this.toaster.add({
                        intent: 'success',
                        message: <Translate content="subscribeMessage" />,
                    });
                } else {
                    this.toaster.add({
                        intent: 'danger',
                        message: <Translate content="errorMessage" />,
                    });
                }
            }
        );
    };

    handleClose = () => {
        const { email, reportConsent, reportConsentUrl } = this.props;
        const { state } = this.state;

        if (state) {
            return;
        }

        const reconfirm = this.needReconfirmConsent();
        this.setState({
            state: 'cancel',
        });

        reportConsent(
            reportConsentUrl,
            email,
            reconfirm ? TYPE_SEND_ANNOUNCE : TYPE_NONE,
            this.getText(),
            success => {
                this.setState({
                    state: null,
                    isOpen: false,
                });

                if (success) {
                    this.toaster.add({
                        intent: 'success',
                        message: <Translate content={reconfirm ? 'noReconfirmMessage' : 'unsubscribeMessage'} />,
                    });
                } else {
                    this.toaster.add({
                        intent: 'danger',
                        message: <Translate content="errorMessage" />,
                    });
                }
            }
        );
    };

    render() {
        const { imageSrc, privacyPolicyUrl } = this.props;
        const { isOpen, state } = this.state;

        const reconfirm = this.needReconfirmConsent();
        return (
            <Fragment>
                <Dialog
                    isOpen={isOpen}
                    size="sm"
                    banner={imageSrc}
                    title={<Translate content={reconfirm ? 'reconfirmTitle' : 'title'} />}
                    form={{
                        state,
                        onSubmit: this.handleSubscribe,
                        submitButton: { children: <Translate content={reconfirm ? 'reconfirmButton' : 'subscribeButton'} /> },
                        cancelButton: { children: <Translate content="closeButton" /> },
                        hideRequiredLegend: true,
                    }}
                    onClose={this.handleClose}
                >
                    {!reconfirm &&
                    <p>
                        <Translate content="text" />
                    </p>}
                    {this.renderInfo()}
                    <p>
                        <Translate
                            content={reconfirm ? 'reconfirmConsent' : 'consent'}
                            params={{ privacyPolicy: <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer"><Translate content="privacyPolicy" /></a> }}
                        />
                    </p>
                </Dialog>
                <Toaster ref={ref => (this.toaster = ref)} />
            </Fragment>
        );
    }
}

NewsletterSubscription.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    reportConsent: PropTypes.func.isRequired,
    privacyPolicyUrl: PropTypes.string.isRequired,
    reportConsentUrl: PropTypes.string.isRequired,
    dialogShown: PropTypes.bool.isRequired,
    consents: PropTypes.array.isRequired,
};

NewsletterSubscription.contextTypes = {
    locale: PropTypes.object,
};

export default NewsletterSubscription;



// WEBPACK FOOTER //
// ./app/newsletter-subscription/NewsletterSubscription.js